import { render, staticRenderFns } from "./CreateContract.vue?vue&type=template&id=afe10172&scoped=true"
import script from "./CreateContract.vue?vue&type=script&lang=js"
export * from "./CreateContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe10172",
  null
  
)

export default component.exports